export default "__VITE_ASSET__CeDNFjDs__"